const DEFAULT_THEME = {
  "fontSettings": {
      "fonts-url": "https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap",
      "font-family": "'Inter', sans-serif",
      "font-optical-sizing":"auto",
      "font-weight": 300,
      "font-style":"normal",
      "font-size":"12pt"
  },
  "colors": {
      "color_info": "#3c8ef7",
      "color_primary": "#091f68",
      "color_secondary": "#9dcbef",
      "color_background": "#000000",
      "color_main": "#000000",
      "color_white": "#fff",
      "color_black": "#000",
      "color_warning": "#f8d161",
      "color_success": "#4caf50",
      "color_danger": "#f44336",
      "color_gray-100": "#f5f5f5",
      "color_gray-200": "#eeeeee",
      "color_gray-300": "#e0e0e0",
      "color_gray-400": "#bdbdbd",
      "color_gray-500": "#9e9e9e",
      "color_gray-600": "#757575",
      "color_gray-700": "#616161",
      "color_gray-800": "#424242",
      "color_gray-900": "#212121"
  },

  // === Tailwind design tokens =============================================
  // Persisted under ThemeSetting.Extras.tailwind in the backend. Override at
  // runtime by setting the matching CSS variables on :root (app-wide) or on
  // a wrapper element (scoped — e.g. formbuilder-v1 instances for a project).
  "tailwind": {
    "radius": {
      "sm": "0.25rem",
      "md": "0.5rem",
      "lg": "0.75rem",
      "xl": "1rem",
      "2xl": "1.5rem",
      "full": "9999px"
    },
    "shadow": {
      "sm": "0 1px 2px 0 rgb(0 0 0 / 0.05)",
      "md": "0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)",
      "lg": "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      "xl": "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)"
    },
    // Tailwind 4 derives p-1, p-2, ... from a single --spacing base. We expose
    // the base AND a few canonical sizes so the theme editor can also override
    // specific steps if needed.
    "spacing": {
      "base": "0.25rem"
    },
    "fontSize": {
      "xs":   "0.75rem",
      "sm":   "0.875rem",
      "base": "1rem",
      "lg":   "1.125rem",
      "xl":   "1.25rem",
      "2xl":  "1.5rem"
    },
    // NOTE: fontFamily.sans/mono are intentionally NOT defaulted here.
    // buildThemeCssVars emits --font-sans as `fontFamily.sans || fontSettings
    // .font-family || 'Inter'`. Seeding fontFamily.sans with a default Inter
    // here would shadow the tenant's `fontSettings.font-family` (the Theme
    // Editor "Font" picker), so changing the Font never retyped the app — the
    // picker only fed the legacy --font-family var, not --font-sans.
    // The hard Inter/mono defaults live in tailwind.css @theme (--font-sans /
    // --font-mono), so the no-tenant-font case is still covered. Tenants who
    // want an explicit Tailwind override can still set extras.tailwind
    // .fontFamily.sans — it takes precedence when present.
    "fontWeight": {
      "normal": 400,
      "medium": 500,
      "bold":   700
    },
    "label": {
      "fontSize":      "0.625rem",
      "fontWeight":    700,
      "color":         "var(--color-gray-500, #6b7280)",
      "textTransform": "uppercase",
      "letterSpacing": "0.05em"
    },
    // Accent — active / hover / selected states across the app. Defaults
    // missing here mean the runtime falls back to `color_primary` (navy)
    // via buildThemeCssVars. The keys exist so the editor and live preview
    // both see the path and can override it without seeding new structure.
    "accent": {
      "color":      "",
      "colorHover": ""
    },
    // Button interaction effect — global enum: none | ripple | lift |
    // scale | glow | shimmer. Driven by the data-button-effect attribute
    // the UWEThemeContext sets on <html>. "lift" is the gentle default
    // that doesn't compete with the content but signals interactivity.
    "button": {
      "effect": "lift"
    },
    // Per-customfield overrides. The Button and Card entries below set the
    // BASELINE values every <Button> and themable card consume via
    // useFieldTheme. Without them, the inline style on each button resolves
    // to `revert-layer` and the buttons don't pick up any effect from the
    // theme cascade — the symptom users hit as "button effects only work
    // in the editor preview, not in the app".
    "customFields": {
      "textInput":     {},
      "textArea":      {},
      "select":        {},
      "checkbox":      {},
      "dateWidget":    {},
      "moneyInput":    {},
      "fileField":     {},
      "signatureField":{},
      // Generic Button bridge — every ButtonX variant falls back here.
      "Button": {
        "radius":     "var(--radius-xl)",
        "padding":    "0.5rem 1rem",
        "fontWeight": "var(--font-weight-medium)",
        "shadow":     "0 1px 2px 0 rgb(0 0 0 / 0.05)"
      },
      // Card chrome — used by WorkTray, SearchBar, SwitchBoard. The
      // header/footer band tokens are the additions that unlock the
      // "customize header background separately" capability we added
      // recently.
      "Card": {
        "radius":            "var(--radius-2xl)",
        "padding":           "1.25rem",
        "shadow":            "0 1px 3px rgb(0 0 0 / 0.05)",
        "borderColor":       "var(--border-color)",
        "background":        "#ffffff",
        "headerBg":          "#fafafa",
        "headerBorderColor": "var(--border-color)",
        "footerBg":          "#fafafa",
        "footerBorderColor": "var(--border-color)"
      }
    }
  }
};


export default DEFAULT_THEME;
